module.exports = __webpack_public_path__ + "img/perez1.90ef8ddd.png";